<template>
  <b-modal
    v-model="tenantModal.status"
    title="Kiracı İşlemleri"
    centered
    size="lg"
    hide-footer
    no-close-on-backdrop
    no-close-on-esc
  >
    <b-alert
      show
      :variant="tenantModal.type === 'infoUpdate'? 'info' : 'warning'"
    >
      <div class="alert-body text-center">
        <span v-if="tenantModal.type === 'infoUpdate'"> Bilgi Güncelleme İşlemi </span>
        <span v-if="tenantModal.type === 'renewal'"> Sözleşme Yenileme İşlemi </span>
        <span v-if="tenantModal.type === 'ended'"> Sözleşme Sonlandırma İşlemi </span>
      </div>
    </b-alert>
    <b-row>
      <b-col>
        <tenant-code />
      </b-col>
      <b-col>
        <tenant-title />
      </b-col>
      <b-col>
        <tenant-phone />
      </b-col>
    </b-row>
    <template v-if="tenantModal.type === 'infoUpdate'">
      <b-row>
        <b-col>
          <tenant-start />
        </b-col>
        <b-col>
          <tenant-amount />
        </b-col>
      </b-row>
    </template>
    <template v-else-if="tenantModal.type === 'renewal'">
      <b-row>
        <b-col>
          <tenant-start is-disabled />
        </b-col>
        <b-col>
          <tenant-end />
        </b-col>
      </b-row>
      <hr>
      <b-row>
        <b-col>
          <tenant-renewal-start />
        </b-col>
        <b-col>
          <tenant-renewal-amount />
        </b-col>
      </b-row>
    </template>
    <template v-else-if="tenantModal.type === 'ended'">
      <b-row>
        <b-col cols="12">
          <tenant-start is-disabled />
        </b-col>
        <b-col cols="12">
          <tenant-end />
        </b-col>
      </b-row>
    </template>
    <div class="d-flex align-items-center justify-content-between border-top pt-1">
      <b-button
        variant="success"
        @click="submitData"
      >
        <span v-if="tenantModal.type === 'infoUpdate'"> <FeatherIcon icon="EditIcon" /> Bilgi Güncelle </span>
        <span v-if="tenantModal.type === 'renewal'"> <FeatherIcon icon="RefreshCwIcon" /> Sözleşme Yenile </span>
        <span v-if="tenantModal.type === 'ended'"> <FeatherIcon icon="XCircleIcon" /> Sözleşme Sonlandır </span>
      </b-button>
    </div>
  </b-modal>
</template>
<script>
import {
  BRow,
  BCol,
  BButton,
  BAlert,
} from 'bootstrap-vue'
import TenantCode from '@/views/Admin/Estates/elements/TenantModal/TenantCode.vue'
import TenantTitle from '@/views/Admin/Estates/elements/TenantModal/TenantTitle.vue'
import TenantPhone from '@/views/Admin/Estates/elements/TenantModal/TenantPhone.vue'
import TenantStart from '@/views/Admin/Estates/elements/TenantModal/TenantStart.vue'
import TenantEnd from '@/views/Admin/Estates/elements/TenantModal/TenantEnd.vue'
import TenantAmount from '@/views/Admin/Estates/elements/TenantModal/TenantAmount.vue'
import TenantRenewalStart from '@/views/Admin/Estates/elements/TenantModal/TenantRenewalStart.vue'
import TenantRenewalAmount from '@/views/Admin/Estates/elements/TenantModal/TenantRenewalAmount.vue'

export default {
  name: 'TenantModal',
  components: {
    TenantCode,
    TenantTitle,
    TenantPhone,
    TenantStart,
    TenantEnd,
    TenantAmount,
    TenantRenewalStart,
    TenantRenewalAmount,
    BRow,
    BCol,
    BButton,
    BAlert,
  },
  props: {
    refreshData: {
      type: Function,
      required: true,
    },
  },
  computed: {
    dataItem() {
      return this.$store.getters['estates/dataItem']
    },
    tenantModal() {
      return this.$store.getters['estates/tenantModal']
    },
  },
  methods: {
    submitData() {
      if (this.tenantModal.type === 'infoUpdate') {
        this.$store.dispatch('estates/tenantUpdate', {
          type: this.tenantModal.type,
          id: this.dataItem.tenants.id,
          sdate: this.dataItem.tenants.sdate,
          amount: this.dataItem.tenants.amount,
        }).then(response => {
          if (response) {
            this.refreshData()
            this.tenantModal.status = false
            this.tenantModal.type = null
          }
        })
      }
      if (this.tenantModal.type === 'renewal') {
        this.$store.dispatch('estates/tenantUpdate', {
          type: this.tenantModal.type,
          id: this.dataItem.tenants.id,
          edate: this.dataItem.tenants.edate,
          renewal_sdate: this.dataItem.tenants.renewal_sdate,
          renewal_amount: this.dataItem.tenants.renewal_amount,
        }).then(response => {
          if (response) {
            this.refreshData()
            this.tenantModal.status = false
            this.tenantModal.type = null
          }
        })
      }
      if (this.tenantModal.type === 'ended') {
        this.$store.dispatch('estates/tenantUpdate', {
          type: this.tenantModal.type,
          id: this.dataItem.tenants.id,
          edate: this.dataItem.tenants.edate,
        }).then(response => {
          if (response) {
            this.refreshData()
            this.tenantModal.status = false
            this.tenantModal.type = null
          }
        })
      }
    },
  },
}
</script>
